var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFantom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_2770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 48C37.405 48 48.1501 37.2548 48.1501 24C48.1501 10.7452 37.405 0 24.1501 0C10.8953 0 0.150146 10.7452 0.150146 24C0.150146 37.2548 10.8953 48 24.1501 48Z",
    fill: "#13B5EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9501 19.35L31.3501 16.2V22.5L25.9501 19.35ZM31.3501 32.85L24.1501 37.05L16.9501 32.85V25.5L24.1501 29.7L31.3501 25.5V32.85ZM16.9501 16.2L22.3501 19.35L16.9501 22.5V16.2ZM25.0501 20.85L30.4501 24L25.0501 27.15V20.85ZM23.2501 27.15L17.8501 24L23.2501 20.85V27.15ZM30.4501 14.7L24.1501 18.3L17.8501 14.7L24.1501 10.95L30.4501 14.7ZM15.1501 14.1V33.75L24.1501 38.85L33.1501 33.75V14.1L24.1501 9L15.1501 14.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_2770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.150146)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantom);
export default __webpack_public_path__ + "static/media/Fantom.5eaf342e43404ce4f1ded983fe6bb997.svg";
export { ForwardRef as ReactComponent };